// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {GLOBAL_COLORS} from '../util/colors';

export const LoaderWrapper = styled.div`
  position: relative;
`;
LoaderWrapper.displayName = 'S.LoaderWrapper';

export const Wrapper = styled.div``;
Wrapper.displayName = 'S.Wrapper';

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 34px;
  margin-bottom: 12px;
  .image-icon-header {
    margin: 0;
  }
`;
HeaderWrapper.displayName = 'S.HeaderWrapper';

export const ActiveWrapper = styled.div`
  display: flex;
  align-items: center;
`;
ActiveWrapper.displayName = 'S.ActiveWrapper';

export const UsersWrapper = styled.div`
  display: flex;
  align-items: center;
`;
UsersWrapper.displayName = 'S.UsersWrapper';

export const MoreUsers = styled.div`
  border-radius: 50%;
  background: ${GLOBAL_COLORS.outline.toString()};
  width: 32px;
  height: 32px;
  text-align: center;
  span {
    margin-top: 3px;
    display: inline-block;
  }
`;
MoreUsers.displayName = 'S.MoreUsers';

export const menuWrapper = styled.div`
  .project-action-menu {
    height: 24px;
    width: 24px;
    transform: translateY(-4px);
  }
`;
menuWrapper.displayName = 'S.menuWrapper';

export const BreakableLine = styled.div`
  overflow-wrap: break-word;
`;
BreakableLine.displayName = 'S.BreakableLine';
